import { Fragment } from 'react';
import { MTInspectionReportData } from '../../../../utils/models';
import { getMTIColumns } from '../../../../utils/data';

import GridItem from '../general/gridItem';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

interface PAUTMTIReportProps extends MTInspectionReportData {}

const PAUTMTIReport = (props: PAUTMTIReportProps) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Surface condition:"
							value={props.surfaceCondition}
						/>
						<GridItem title="Stage of test:" value={props.testStage} />
						<GridItem title="Equipment:" value={props.equipment} />
						<GridItem title="Method:" value={props.method} />
						<GridItem title="Ref Std:" value={props.refStd} />
					</div>

					<div className="col">
						<GridItem
							title="Magnetic Medium used:"
							value={props.magneticMediumUsed}
						/>
						<GridItem title="Current used:" value={props.currentUsed} />
						<GridItem
							title="Background contrast medium used:"
							value={props.bgContrastMediumUsed}
						/>
						<GridItem title="Technique:" value={props.technique} />
						<GridItem title="Acceptance  Std:" value={props.acceptanceStd} />
					</div>
				</div>

				<GridItem title="Material:" value={props.material as string} />
			</div>

			<PDFTablePage data={props.data ?? []} columns={getMTIColumns()} />
		</Fragment>
	);
};

export default PAUTMTIReport;
